/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
export * from './menuMapping';
export * from './order';
export * from './operation';
export * from './event';
export * from './project'; // 角色详细信息

export var roleLabelMapping = {
  1: '工单管理',
  2: '查看自己的工单',
  3: '所有权限',
  4: '发起与评价内部工单',
  5: '帮客户下单',
  6: '受理渠道订单',
  7: '按计划回访',
  8: '财务对账与结算',
  9: '库存管理与审批',
  10: '查阅工单与运营数据'
}; // 系统角色

export var sysRoleType = {
  SYS_ROLE_DELIVER: 1,
  // 派单员
  SYS_ROLE_WORKER: 2,
  // 上门工人
  SYS_ROLE_BOSS: 3,
  // 老板
  SYS_ROLE_EMPLOYEE: 4,
  // 普通员工
  SYS_ROLE_BUSINESS: 5,
  // 业务员
  SYS_ROLE_ACCEPT_CUSTOMERSERVICE: 6,
  // 受理客服
  SYS_ROLE_RETURNVISIT_CUSTOMERSERVICE: 7,
  // 回访客服
  SYS_ROLE_FINANCE: 8,
  // 财务人员
  SYS_WAREHOUSE_KEEPER: 9,
  // 仓库管理员
  SYS_CHIEF_INSPECTOR: 10 // 管理总监

}; // keep-alive 缓存（需组件内部export name属性）

export var keepAliveList = ['FAQ', 'Home', 'Operation', 'Order', 'Event', 'Mine', 'SendMe', 'TimeoutOrder', 'VisitOrder', 'OrderMap', 'customerView', 'MapView', 'Project'];
export var whiteList = ['PasswordForget', 'CodeLogin', 'Passwordset', 'Guide', 'Privacy', 'Register']; // 备件操作类型

export var spareOperationType = {
  1: '工单消耗',
  2: '取消消耗',
  3: '入库',
  4: '出库',
  5: '调拨',
  6: '回收',
  7: '申领',
  8: '退库',
  9: '分配',
  10: '盘点',
  11: '报废',
  12: '翻新',
  13: '转交'
};
export var sysCodeType = {};
export var proFormFilterList = [{
  value: 0,
  name: '待提交',
  color: '#fa5d3a',
  mapState: [{
    submit_state: 0
  }],
  mapStateIndex: 0
}, {
  value: 1,
  name: '待审批',
  color: '#0075ed',
  mapState: [{
    approval_state: 0,
    is_required_approval: 1
  }],
  mapStateIndex: 0
}, {
  value: 2,
  name: '已通过',
  color: '#e49100',
  mapState: [{
    submit_state: 1,
    is_required_approval: 0
  }, {
    submit_state: 1,
    is_required_approval: 1,
    approval_state: 1
  }],
  mapStateIndex: 0
}, {
  value: 3,
  name: '已驳回',
  color: '#0abd12',
  mapState: [{
    submit_state: 1,
    is_required_approval: 1,
    approval_state: 2
  }],
  mapStateIndex: 0
}];
export var getProFormFilterState = function getProFormFilterState(event) {
  function _objToMap(obj, map) {
    var res = false;
    var keys = Object.keys(map);
    res = keys.every(function (key) {
      var value = map[key];

      if (Array.isArray(value)) {
        return value.includes(obj[key]);
      } else {
        return value === obj[key];
      }
    });
    return res;
  }

  for (var index = 0; index < proFormFilterList.length; index++) {
    var nonce = proFormFilterList[index];
    var mapState = nonce.mapState;
    var res = mapState.find(function (v) {
      return _objToMap(event, v);
    });

    if (res) {
      nonce.mapStateIndex = mapState.findIndex(function (v) {
        return _objToMap(event, v);
      });
      return nonce;
    }
  }

  var defaultValue = {
    value: -1,
    name: '状态异常',
    color: '#ff4d4f'
  };
  return defaultValue;
};